import {peakAlert} from "../../../PeakDialog.js";
import jQuery from "jquery";
import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";

let $ = jQuery.noConflict();
export class ZIDXAccountDataFeedEdit implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountDataFeedEditContainer";
    }
    render(){
        let self=this;
        // console.log("data feed edit");
        $("#listing_feed_enable_listing_download1", this.zidx.peakidxShadowRoot).on("click", function(e:JQuery.ClickEvent){
            let listing_feed_listing_timestamp_field=$("#listing_feed_listing_timestamp_field", $(".zidxPageActive", self.zidx.peakidxShadowRoot)).val();
            let listing_feed_photo_timestamp_field=$("#listing_feed_photo_timestamp_field", $(".zidxPageActive", self.zidx.peakidxShadowRoot)).val();
            let listing_feed_listing_id_field=$("#listing_feed_listing_id_field", $(".zidxPageActive", self.zidx.peakidxShadowRoot)).val();
            let listing_feed_listing_type_field=$("#listing_feed_listing_type_field", $(".zidxPageActive", self.zidx.peakidxShadowRoot)).val();
            let listing_feed_photo_count_field=$("#listing_feed_photo_count_field", $(".zidxPageActive", self.zidx.peakidxShadowRoot)).val();
            let listing_feed_media_field=$("#listing_feed_media_field", $(".zidxPageActive", self.zidx.peakidxShadowRoot)).val();
            let listing_feed_photo_key_field=$("#listing_feed_photo_key_field", $(".zidxPageActive", self.zidx.peakidxShadowRoot)).val();
            let propertySettingCount=0;
            if(listing_feed_listing_timestamp_field==""){
                propertySettingCount++;
            }
            if(listing_feed_photo_timestamp_field==""){
                propertySettingCount++;
            }
            if(listing_feed_listing_id_field==""){
                propertySettingCount++;
            }
            if(listing_feed_listing_type_field==""){
                propertySettingCount++;
            }
            if(listing_feed_photo_count_field==""){
                propertySettingCount++;
            }
            // if(listing_feed_media_field==""){
            //     propertySettingCount++;
            // }
            // if(listing_feed_photo_key_field==""){
            //     propertySettingCount++;
            // }
            if(propertySettingCount!=0) {
                peakAlert("You can't enable listing data download unless all \"Property Settings\" are populated first.");
                $("#listing_feed_enable_listing_download0", self.zidx.peakidxShadowRoot).trigger("click");
            }
        });
    }
}